class RRDrawerVisibility extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    const header = this.closest('.shopify-section');
    const drawers = [...header.querySelectorAll('header-search, #sidebar-menu')];
    const sync = element => {
      const displayed = element.style.display === 'block';
      if (element.hasAttribute('data-rr-displayed') !== displayed) element.toggleAttribute('data-rr-displayed', displayed);
    };
    this.observer = new MutationObserver(records => {
      for (const element of new Set(records.map(record => record.target))) sync(element);
    });
    for (const drawer of drawers) {
      sync(drawer);
      this.observer.observe(drawer, { attributes: true, attributeFilter: ['style'] });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('rr-drawer-visibility')) customElements.define('rr-drawer-visibility', RRDrawerVisibility);
